import { Address, Amount, ChainKey, getChain, WalletKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { Button, getButtonClassNames } from "../button";
import { asFullAmount } from "@silo/utils";
import { AccountBadge, AccountBadgeState } from "./account-badge";
import { tv } from "tailwind-variants";
import { ReactNode } from "react";

export const connectedTrigger = tv({
  base: cn(
    getButtonClassNames("tertiary", "normal"),
    "py-[3px] px-2.5 group sm:w-fit"
  ),
});

export interface ConnectedTriggerProps extends ConnectedTriggerContentProps {
  className?: string;
  onClick: () => void;
}

export function ConnectedTrigger({
  className,
  onClick,
  ...rest
}: ConnectedTriggerProps): JSX.Element {
  return (
    <Button
      onClick={onClick}
      variant="tertiary"
      className={connectedTrigger()}
      data-cy="wallet-info-button"
    >
      <ConnectedTriggerContent {...rest} />
    </Button>
  );
}

interface ConnectedTriggerContentProps {
  className?: string;
  nativeBalance: Amount;
  chainKey: ChainKey;
  account: Address;
  state: AccountBadgeState;
  ensName: string | undefined;
  isImpersonating: boolean;
  walletKey: WalletKey;
  chevron: ReactNode;
}

export function ConnectedTriggerContent({
  className,
  nativeBalance,
  chainKey,
  account,
  state,
  ensName,
  isImpersonating,
  walletKey,
  chevron,
}: ConnectedTriggerContentProps): JSX.Element {
  const {
    nativeCurrency: { symbol, decimals },
  } = getChain(chainKey);

  return (
    <div className={cn("flex items-center justify-between gap-2.5", className)}>
      <div className="text-sm font-medium text-shale-200">
        {asFullAmount(nativeBalance, decimals)} {symbol}
      </div>

      <div className="flex items-center gap-2.5">
        <AccountBadge
          account={account}
          ensName={ensName}
          state={state}
          isImpersonating={isImpersonating}
          walletKey={walletKey}
        />

        {chevron}
      </div>
    </div>
  );
}
